import { render } from "./Viber.vue?vue&type=template&id=69cf46de"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Viber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69cf46de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69cf46de', __exports__)) {
    api.reload('69cf46de', __exports__)
  }
  
  module.hot.accept("./Viber.vue?vue&type=template&id=69cf46de", () => {
    api.rerender('69cf46de', render)
  })

}


export default __exports__